import React from 'react'
import emptyImg from '../../images/chat-empty.png'


export default function () {
    return (
        <div className="message-empty">
            <div className="content">
                <div className="title">此处暂无消息哦</div>
                <div className="icon">
                    <img src={emptyImg} alt=""/>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/message/Empty.js